var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _rect5, _path6, _rect6, _rect7, _path7, _rect8, _path8, _rect9, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTree = function SvgTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 623,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    x: 32,
    y: 253,
    fill: "#B2E946",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 127.838,
    height: 118.25,
    x: 33,
    y: 264.75,
    fill: "#9ACA3B",
    rx: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M79 308h18m-33-12h18"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 151,
    y: 507,
    fill: "#B2E946",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 31
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 97.117,
    height: 89.833,
    x: 152,
    y: 516.167,
    fill: "#9ACA3B",
    rx: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M212 539h18m-58 35h18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#906925",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M-63.5 163a7 7 0 0 1 7 7v36a3 3 0 0 0 3 3H28a7 7 0 1 1 0 14h-81.5c-9.389 0-17-7.611-17-17v-36a7 7 0 0 1 7-7zM123 531a7 7 0 0 0-7 7v36a3 3 0 0 1-3 3H23a7 7 0 1 0 0 14h90c9.389 0 17-7.611 17-17v-6h26.5a7 7 0 1 0 0-14H130v-16a7 7 0 0 0-7-7z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#906925",
    d: "M-16 942.709S-7.366 327.367-8.273 135h65.546L64 942.709z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.62 715.379h38.093M23.5 500.209h26m-15.5-14h15.5m-46.88-133.5H28.5m-25.88-12H15m8.5-121h33.773M-8.273 135C-7.366 327.367-16 942.709-16 942.709h80L57.273 135z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 112,
    fill: "#527213",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 30,
    transform: "matrix(1 0 0 -1 -67 162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M77 106h18"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    x: -6,
    y: 1,
    fill: "#B2E946",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 83.243,
    height: 77,
    x: -5,
    y: 9,
    fill: "#9ACA3B",
    rx: 30
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M21.571 38H37m-6.857 15.429H45.57"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 72.092,
    x: -85,
    y: 288,
    fill: "#527213",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 30
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M7.69 324.046h11.586"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 112,
    x: -20,
    y: 436,
    fill: "#527213",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 30
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7EA82B",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M14 512h18m-33-12h18m107-8h18"
  })));
};
export default SvgTree;